import { Link } from "react-router-dom";
import { useAuth } from "react-oidc-context";

import { getUserRoles, getUsername, hasRealmRole } from "@/auth/roles";
import BrandLogo from "@/components/BrandLogo";

const TERMINOLOGY_REVIEWER_ROLE = "terminology_reviewer";

/** Публичная главная: если не авторизован — кнопка «Войти». Если уже
 *  авторизован — показываем выбор: Перевод / Очередь ревью (для тех у
 *  кого есть роль). Без авто-редиректов. */
export default function Home() {
  const auth = useAuth();

  if (auth.isLoading) {
    return (
      <div className="mt-home">
        <div className="mt-home__center">
          <p className="cl-min__sub">Загрузка…</p>
        </div>
      </div>
    );
  }

  if (auth.isAuthenticated) {
    const roles = getUserRoles(auth.user);
    const isReviewer = hasRealmRole(auth.user, TERMINOLOGY_REVIEWER_ROLE);
    const username = getUsername(auth.user);
    return (
      <div className="mt-home">
        <main className="mt-home__center">
          <div className="cl-min__hero">
            <h1 className="cl-min__h1">medtranslate</h1>
            <p className="cl-min__sub">Привет, {username}.</p>
          </div>
          <div className="mt-home__cta">
            <Link to="/translate" className="mt-btn mt-btn--primary mt-btn--lg">
              Перейти к переводу
            </Link>
            <Link
              to="/admin/review"
              className="mt-btn mt-btn--secondary mt-btn--lg"
            >
              {isReviewer ? "Очередь ревью" : "Очередь ревью (нет роли)"}
            </Link>
          </div>
          <div
            className="mt-text-tight mt-muted"
            style={{ marginTop: "var(--sp-3)", fontSize: "var(--fs-xs)" }}
          >
            Роли: {roles.length > 0 ? roles.join(", ") : "(нет)"}
            {" · "}
            <button
              className="mt-link"
              onClick={() => void auth.signoutRedirect()}
              type="button"
              style={{ background: "none", border: 0, padding: 0, cursor: "pointer" }}
            >
              Выйти
            </button>
          </div>
        </main>
      </div>
    );
  }

  return (
    <div className="mt-home">
      <header className="cl-min__top">
        <BrandLogo />
      </header>
      <main className="mt-home__center">
        <div className="cl-min__hero">
          <h1 className="cl-min__h1">medtranslate</h1>
          <p className="cl-min__sub">
            Рабочее пространство для медицинских переводов с автоматической
            подстановкой терминологии и проверками качества.
          </p>
        </div>
        <div className="mt-home__cta">
          <button
            className="mt-btn mt-btn--primary mt-btn--lg"
            onClick={() => {
              sessionStorage.setItem("mt:postLoginRedirect", "/translate");
              void auth.signinRedirect();
            }}
            type="button"
          >
            Войти
          </button>
        </div>
        {auth.error && (
          <div
            className="mt-empty mt-empty--error"
            role="alert"
            style={{ marginTop: "var(--sp-3)" }}
          >
            {auth.error.message}
          </div>
        )}
      </main>
    </div>
  );
}
